'use strict';
const urlHelper = require('../util/url-helper'),
	removeExtraSpaces = require('@mindmup/js-utils/src/remove-extra-spaces'),
	cleanNonPrintable = require('@mindmup/js-utils/src/clean-non-printable'),
	trimLines = require('@mindmup/js-utils/src/trim-lines'),
	removeLinks = function (nodeTitle, maxUrlLength) {
		const strippedTitle = nodeTitle && urlHelper.stripLink(nodeTitle);
		if (strippedTitle.trim() === '') {
			return (!maxUrlLength || (nodeTitle.length < maxUrlLength) ? nodeTitle : (nodeTitle.substring(0, maxUrlLength) + '...'));
		}  else {
			return strippedTitle;
		}
	};
module.exports = function (nodeTitle, maxUrlLength) {
	if (!nodeTitle || !nodeTitle.trim()) {
		return '';
	}
	const sanitizedTitle = cleanNonPrintable(nodeTitle),
		withoutLinks = removeLinks(sanitizedTitle, maxUrlLength),
		withConsolidatedSpaces = removeExtraSpaces(withoutLinks);
	return trimLines(withConsolidatedSpaces);
};

